module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['online-status', {
      'online-status--active': _vm.status === true,
      'online-status--inactive': _vm.status === false,
    }]
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24c2a837!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/OnlineStatus.vue
// module id = 1145
// module chunks = 2